import * as React from 'react';
import { ReactComponent as Icon } from './search.svg';
import { IconProps } from '../IconProps';

const Search: React.FC<IconProps> = (props) => <Icon {...props} />;

export default Search;
export type { IconProps };
